import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import useVoidOrderTransaction from '../../../requests/useVoidOrderTransaction';
import useDisplayMessage from '../../Common/useDisplayMessage';
import KaAlert from '../../Common/KaAlert';
import SpinnerButton from '../../Common/SpinnerButton';

interface VoidOrderTransactionModalProps {
  onHide: () => void;
  orderTransactionId: string;
  orderTransactionNumber: string;
  onSuccess: () => void;
}

const VoidOrderTransactionModal = (props: VoidOrderTransactionModalProps) => {
  const [reason, setReason] = useState('');
  const displayMessage = useDisplayMessage();
  const voidOrderTransaction = useVoidOrderTransaction(props.orderTransactionId, {
    onSuccess: props.onSuccess,
    onError: err => displayMessage.fail(err.message),
  });

  return (
    <Modal show={true} onHide={props.onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Void Order Transaction</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
        <p>
          Voiding this transaction will unapply its dispensed amounts from the order's total
          and will prevent this transactions totals from being applied when exporting the order
          through an integration. Are you sure you want to void this order transaction? This action cannot be undone.
        </p>
        <Form.Group className="mb-3 mt-6">
          <Form.Label htmlFor="voidReason">
            Reason for voiding (optional)
          </Form.Label>
          <Form.Control
            id="voidReason"
            as="textarea"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter the reason for voiding this transaction..."
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <SpinnerButton
          className="btn-ghost-danger"
          onClick={() => voidOrderTransaction.request({ reason })}
          spinning={voidOrderTransaction.isLoading}
        >
          Void Order Transaction
        </SpinnerButton>
      </Modal.Footer>
    </Modal>
  );
};

export default VoidOrderTransactionModal;